import Threshold from 'constants/threshold'
import useWindowSize from 'hooks/useWindowSize'
import styled from 'styled-components'

export const SearchWrapper = styled.div`
  max-width: 720px;
  display: grid;
  margin: 0 auto 15px;
  grid-template-rows: 1fr 1fr;
  width: 85%;
  @media (min-width: ${Threshold.tablet}) {
    max-width: 1100px;
    width: 100%;
    display: flex;
    margin: 0 auto 30px;
  }
`
export const InputWrapper = styled.div`
  max-width: 686px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 15px;
  @media (min-width: ${Threshold.tablet}) {
    max-width: 720px;
    margin-right: 35px;
    margin-left: 20px;
    margin-bottom: 0;
  }
`

export const ButtonWrapper = styled.div`
  max-width: 686px;
  width: 100%;
  max-height: 60px;
  margin: 0 auto;
  @media (min-width: ${Threshold.tablet}) {
    max-width: fit-content;
    margin-right: 0;
    margin-left: 0;
  }
`
